import tips from './tips'
import copay from './copay'
import delivery from './delivery'

export default {
  'approve-type': {
    'face-2-face-id-required': {
      label: 'Identificação e assinatura presenciais obrigatórias',
      description_1: 'A receita será entregue apenas ao paciente indicado. O destinatário precisa apresentar documento de identidade e assinar, e o nome no documento deve corresponder ao do destinatário.',
      description_2: 'O motorista tirará uma foto do documento do paciente e da porta no momento da entrega.',
    },
    'face-2-face-not-required': {
      label: 'Assinatura presencial não obrigatória',
      description: 'É necessária a assinatura de qualquer adulto (18+) que more com o paciente. O motorista tirará uma foto da porta do paciente.',
    },
    'face-2-face-required': {
      label: 'Assinatura presencial obrigatória',
      description: 'É necessária a assinatura de qualquer pessoa que more com o paciente. O motorista tirará uma foto da porta do paciente.',
    },
    'non-contract-delivery': {
      label: 'Entrega sem contato',
      description: 'O motorista deixará o pacote na porta e tirará uma foto, sem tentar a entrega presencial.',
    },
    'online-signature': {
      label: 'Assinatura online',
      description_1: 'O motorista deixará a receita na porta e tirará uma foto, apenas',
      description_2: 'se o destinatário assinar online antes da entrega. Sem assinatura online, o método de entrega',
      description_3: 'passará a ser \'Assinatura presencial obrigatória\'.',
    },
    'signature-optional': {
      label: 'Assinatura opcional',
      description: 'O motorista tentará a entrega presencial. Se não houver ninguém em casa, deixará o pacote na porta e tirará uma foto.',
    },
  },
  wait: 'Aguarde, por favor...',
  'promised-eta': 'Previsão de entrega:',
  reschedule: 'Reagendar/Alterar endereço',
  tips,
  copay,
  delivery,
  dates: {
    today: 'Hoje',
    tomorrow: 'Amanhã',
    'today-at': 'Hoje às {time}',
    'date-at': '{date} às {time}',
    'before-time': 'antes das {time}',
    'time-until': '{from} - {time}',
    'time-from': '{time} - {to}',
    apt: 'apto',
    'delivery-unavailable': 'Data de entrega indisponível',
  },
  payment: {
    error: 'Erro',
    success: 'Sucesso',
    'transaction-error': 'Erro na transação: {message}',
    okay: 'Ok',
    'copay-success': 'Coparticipação paga com sucesso',
    'success-bang': 'Sucesso!',
  },
  role: {
    driver: 'Motorista',
    dispatcher: 'Despachante',
  },
  'address-check': {
    title: 'Endereço alterado',
    entered: 'Endereço informado:',
    validated: 'Endereço validado:',
    accept: 'ACEITAR ALTERAÇÕES',
    keep: 'Meu endereço está correto',
    cancel: 'Cancelar',
  },
  push: {
    title: 'Ativar notificações push',
    message: 'Receba atualizações imediatas do status da entrega pelas notificações do navegador.',
  },
}
